import {loadCreditCards} from "@awe-web/shared/lib/user/actions.js";

export const initialize = () => async (dispatch) => {
  await dispatch(loadCreditCards());
};
